import type { RiskReductionMeasure } from '@/shared/hooks/api/machineryDirectiveCompliance'
import type { TFunction } from 'i18next'

type RrmStandardProvenanceInput = Pick<
  RiskReductionMeasure,
  'source' | 'sourceStandardReference' | 'sourceClauseReference'
>

export function getRrmStandardProvenanceLabel(
  riskReductionMeasure: RrmStandardProvenanceInput,
  translate: TFunction<'machineryDirectiveCompliance'>
): string | null {
  if (riskReductionMeasure.source !== 'STANDARD') {
    return null
  }

  const standardReference =
    riskReductionMeasure.sourceStandardReference?.trim() ?? ''
  const clauseReference =
    riskReductionMeasure.sourceClauseReference?.trim() ?? ''

  if (standardReference.length > 0 && clauseReference.length > 0) {
    return translate(
      'riskReductionMeasuresLibraryPage.standardProvenance.withClause',
      {
        standardReference,
        clauseReference,
      }
    )
  }

  if (standardReference.length > 0) {
    return translate(
      'riskReductionMeasuresLibraryPage.standardProvenance.standardOnly',
      {
        standardReference,
      }
    )
  }

  return translate('riskReductionMeasuresLibraryPage.badges.fromStandards')
}
